<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col cols="3">
					<b-form-select v-model="departmentId" name="departmentId" :disabled="allDeps"
						style="display: inline-block">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>

				</b-col>
				<b-col cols="2">
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col cols="2">
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<b-form-input v-model="itemName" :placeholder="$t('goods.name')" />
				</b-col>
				<b-col>
					<b-form-input v-model="barcode" :placeholder="$t('goods.special-barcode')" />
				</b-col>
				<b-col align="center" style="display: flex">
					<b style="display: inline-block;width: 100px;margin-top: 8px">{{ $t("Whole_firm") }}:</b>
					<b-checkbox class="ml-2" style="display: inline-block;margin-left: 150px;margin-top: 8px"
						v-model="allDeps" switch />
					<b-button @click="getExcelItems" variant="dark" style="width: 40px ;height: 35px;margin-left: 10px"
						class="fa fa-search mr-3" />
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting" style="font-size: 25px;">
							<b-button class="fa fa-th mr-2" variant="dark"
								style="width: 40px ;height: 35px;margin-top: -4px"></b-button>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ ind.label }}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect label="name" track-by="id" v-model="group" :multiple="true" :options="groups"
						:allow-empty="true" :group-select="true" :show-labels="false" class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" v-model="category" :allow-empty="true"
						:group-select="true" :show-labels="false" :options="categorys" class="multiselect-pricing"
						:placeholder="$t('goods.create.category')" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect label="name" track-by="id" v-model="group1" :multiple="true" :options="groups"
						:allow-empty="true" :group-select="true" :show-labels="false" id="danger-multiselect"
						:placeholder="$t('Except_group')" class="multiselect-pricing danger-multiselect" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" v-model="category1" :allow-empty="true"
						:group-select="true" :show-labels="false" :options="categorys1"
						class="multiselect-pricing danger-multiselect" :placeholder="$t('Except_category')" />
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px"><b>DutyFree International</b></div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{ $t("Sales_by_groups_of_money_change") }} {{ $t("c") }} {{ fromDate ? fromDate : '________' }}
							{{ $t("po") }} {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName :
						'__________________'
						}}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<b-table :items="items" :fields="computedfields" :busy="loading" :responsive="true" small bordered
						show-empty striped hover id="gridContainer" label-sort-asc="" label-sort-desc=""
						label-sort-clear="">
						<template #table-busy>
							<div class="text-center my-2">
								<b-spinner small class="mr-2" /><strong>Loading...</strong>
							</div>
						</template>
						<template #cell(id)="data">
							{{ data.index + 1 }}
						</template>
						<template #cell(sumIncomePriceEur)="data">
							{{ data.item.sumIncomePriceEur | currency({
								symbol: '', fractionCount: 2, symbolPosition:
									'back', thousandsSeparator: '', fractionSeparator: ','
}) }}
						</template>
						<template #cell(sumPriceEur)="data">
							{{ data.item.sumPriceEur | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: '', fractionSeparator: ','
}) }}
						</template>
						<template #cell(sumPriceUzs)="data">
							{{ data.item.sumPriceUzs | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: '', fractionSeparator: ','
}) }}
						</template>
						<template #cell(incomePriceEur)="data">
							{{ data.item.incomePriceEur | currency({
								symbol: '', fractionCount: 2, symbolPosition:
									'back', thousandsSeparator: '', fractionSeparator: ','
}) }}
						</template>
						<template #cell(priceEur)="data">
							{{ data.item.priceEur | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: '', fractionSeparator: ','
}) }}
						</template>
					</b-table>
					<b-button v-if="items.length > 0" class="float-right mt-1 hidden-print"
						@click="excelExport1('gridContainer', 'Отчет № 16*')" variant="primary" :disabled="loading">{{
							$t('excel-export.download-excel') }}</b-button>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import UsersService from "../../../services/users.sevice";
import { BTable, VBTable } from "bootstrap-vue";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";
import Multiselect from "vue-multiselect";
import ReferencesService from "../../../services/references.sevice";

export default {
	name: "Продажы по группам",
	components: {
		Multiselect,
		BTable,
		VBTable
	},
	data() {
		return {
			items: [],
			json_to_excel: {
				'Группа': 'group',
				'Подгруппа': 'subGroup',
				'СпецКод': 'barcode',
				'Наименование': 'itemName',
				'Остаток': 'remaning',
				'Продано': 'saleCount',
				'Сумма по приходной': 'sumIncomePriceEur',
				'Сумма по продажной': 'sumPriceEur',
				'Прод.в сумах': 'sumPriceUzs',
				'Внеш.код': 'artikul',
				'Дата прихода': 'regDate',
				'Срок годности': 'termOfItem',
				'Остаток везде': 'd1',
				'цена в UzS за ед-цу': 'd2',
				'сумма в UzS': 'd3',
				'покупная цена в EUR за ед-цу': 'incomePriceEur',
				'прод.цена в EUR за ед-цу': 'priceEur'
			},
			fields: [
				{ key: 'id', label: '№', class: 'text-center', visible: true },
				{ key: 'group', label: this.$t("Группа"), class: 'text-center', visible: true, sortable: true },
				{ key: 'subGroup', label: this.$t("subGroup"), class: 'text-center', visible: true, sortable: true },
				{ key: 'barcode', label: this.$t("СпецКод"), class: 'text-center', visible: true, sortable: true },
				{ key: 'barcodes', label: this.$t("Щтрихкод"), class: 'text-center', visible: true, sortable: true },
				{ key: 'itemName', label: this.$t("name"), class: 'text-center', visible: true, sortable: true },
				{ key: 'remaning', label: this.$t("remaining"), class: 'text-center', visible: true, sortable: true },
				{ key: 'saleCount', label: this.$t("sold"), class: 'text-center', visible: true, sortable: true },
				{ key: 'sumIncomePriceEur', label: this.$t("Incoming_amount"), class: 'text-center', visible: true, sortable: true },
				{ key: 'sumPriceEur', label: this.$t("Selling_amounts"), class: 'text-center', visible: true, sortable: true },
				{ key: 'sumPriceUzs', label: this.$t("Прод.в сумах"), class: 'text-center', visible: true, sortable: true },
				{ key: 'artikul', label: this.$t("External_code"), class: 'text-center', visible: true, sortable: true },
				{ key: 'regDate', label: this.$t("regDate"), class: 'text-center', visible: true, sortable: true },
				{ key: 'termOfItem', label: this.$t("Срок годности"), class: 'text-center', visible: true, sortable: true },
				{ key: 'd1', label: this.$t("The_rest_is_everywhere"), class: 'text-center', visible: true, sortable: true },
				{ key: 'd2', label: this.$t("price_in_UzS_per_unit"), class: 'text-center', visible: true, sortable: true },
				{ key: 'd3', label: this.$t("amount_in_UZS"), class: 'text-center', visible: true, sortable: true },
				{ key: 'incomePriceEur', label: this.$t("incomePriceEur"), class: 'text-center', visible: true, sortable: true },
				{ key: 'priceEur', label: this.$t("priceEur"), class: 'text-center', visible: true, sortable: true }
			],
			departments: [],
			departmentId: null,
			fromDate: null,
			toDate: null,
			itemName: '',
			barcode: '',
			group: null,
			group1: null,
			category: null,
			category1: null,
			groups: [],
			categorys: [],
			categorys1: [],
			groupIds: [],
			groupNots: [],
			categoryIds: [],
			subGroupNots: [],
			allDeps: false,
			loading: false
		}
	},
	watch: {
		allDeps: {
			handler(e) {
				if (e)
					this.departmentId = null
			}
		},
		'group': {
			handler(g) {
				this.groupIds = []
				g.filter(t => this.groupIds.push(t.id))
				if (this.groupIds.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupIds).then(res => {
						this.categorys = res.data
					})
				} else {
					this.categorys = []
				}
				this.category = null
			}
		},
		'category': {
			handler(c) {
				this.categoryIds = []
				c.filter(t => this.categoryIds.push(t.id))
			}
		},
		'group1': {
			handler(g) {
				this.groupNots = []
				g.filter(t => this.groupNots.push(t.id))
				if (this.groupNots.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupNots).then(res => {
						this.categorys1 = res.data
					})
				} else {
					this.categorys1 = []
				}
				this.category1 = null
			}
		},
		'category1': {
			handler(c) {
				this.subGroupNots = []
				c.filter(t => this.subGroupNots.push(t.id))
			}
		},
	},
	computed: {
		computedfields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible) {
					tmp.push(t)
				}
			})
			return tmp
		},
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		}
	},
	methods: {
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			this.fields.forEach(t => {
				delete t.sortable
			})
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			window.print();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		getExcelItems() {
			this.loading = true
			if (this.fromDate && this.toDate) {
				if (this.departmentId || this.allDeps) {
					let data = {
						startDate: this.fromDate,
						endDate: this.toDate,
						deps: this.departmentId,
						allDeps: this.allDeps,
						groups: this.groupIds,
						subGroups: this.categoryIds,
						groupNots: this.groupNots,
						subGroupNots: this.subGroupNots,
						value: this.itemName,
						barcode: this.barcode
					}
					ReportService.getExcelItems(data).then(res => {
						this.items = res.data
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.loading = false
					this.$vs.notify({
						text: "Выберите Подразделение с периодом",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		},
		sumRemaining(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.remaning
			})
			return sum
		},
		sumSaleCount(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.saleCount
			})
			return sum
		},
		sumPrice(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.price
			})
			return sum
		},
		sumPriceUzs(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.priceUzs
			})
			return sum
		},
		itogoSumRemaining(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.remaning
				})
				itog += sum
			})
			return itog
		},
		itogoSumSaleCount(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.saleCount
				})
				itog += sum
			})
			return itog
		},
		itogoSumPrice(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.price
				})
				itog += sum
			})
			return itog
		},
		itogoSumPriceUzs(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.priceUzs
				})
				itog += sum
			})
			return itog
		},
		vsegoRemaining(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.remaning
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoSaleCount(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.saleCount
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoPrice(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.price
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoPriceUzs(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.priceUzs
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		})
		this.getDeps();
	}
}
</script>

<style scoped lang="scss">
@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none !important;
	}

	.nav {
		display: none;
	}

	.nav-pills {
		display: none;
	}

	.flex-column {
		display: none;
	}

	.dnon {
		display: none;
	}
}
</style>
